import React, { useState, useEffect } from 'react';

const ImageModal = ({ isOpen, images, activeIndex, onClose, onNavigate }) => {
  const [fade, setFade] = useState(true);

  useEffect(() => {
    setFade(false);
    const timer = setTimeout(() => setFade(true), 100);
    return () => clearTimeout(timer);
  }, [activeIndex]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col justify-center items-center z-50">
      {/* Botón cerrar */}
      <button
        className="absolute top-4 right-6 text-white text-3xl font-bold hover:text-gray-400 transition"
        onClick={onClose}
      >
        ✕
      </button>

      {/* Imagen principal */}
      <div className="flex items-center justify-center relative w-full max-w-4xl">
        <button
          className="absolute left-4 text-white text-6xl font-extrabold hover:text-gray-400 transition"
          onClick={() => onNavigate(-1)}
        >
          ‹
        </button>

        <img
          src={images[activeIndex]}
          alt="Imagen ampliada"
          className={`rounded-2xl shadow-lg max-h-[80vh] transition-opacity duration-300 ${
            fade ? 'opacity-100' : 'opacity-0'
          }`}
        />

        <button
          className="absolute right-4 text-white text-6xl font-extrabold hover:text-gray-400 transition"
          onClick={() => onNavigate(1)}
        >
          ›
        </button>
      </div>

      {/* Miniaturas debajo */}
      <div className="flex gap-2 mt-6 overflow-x-auto px-4">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Miniatura ${idx + 1}`}
            className={`w-20 h-20 object-cover rounded-lg cursor-pointer transition-transform duration-200 ${
              idx === activeIndex ? 'ring-4 ring-white scale-110' : 'opacity-70 hover:opacity-100'
            }`}
            onClick={() => onNavigate(idx - activeIndex)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageModal;
